import React from "react";
import { DateTime } from "luxon";
import { isNil } from "lodash";
import { Age } from "@ui";
import { ServiceLevelTarget } from "@apollo/ops";

type PaymentAgeProps = {
  placedOn: string;
  deliveredAt?: string | null;
  serviceLevelTarget: ServiceLevelTarget;
};

export function PaymentAge({
  serviceLevelTarget,
  placedOn,
  deliveredAt,
}: PaymentAgeProps) {
  const start = DateTime.fromISO(placedOn);
  const end = isNil(deliveredAt) ? undefined : DateTime.fromISO(deliveredAt);

  return (
    <Age start={start} end={end} serviceLevelTarget={serviceLevelTarget} />
  );
}

type PaymentAgeFromDeliveryProps = {
  freightDeliveredAt?: string | null;
  deliveredAt?: string;
  serviceLevelTarget: ServiceLevelTarget;
};

export function PaymentAgeFromDelivery({
  freightDeliveredAt,
  deliveredAt,
  serviceLevelTarget,
}: PaymentAgeFromDeliveryProps) {
  if (isNil(freightDeliveredAt)) {
    return <span>N/A</span>;
  }

  const start = DateTime.fromISO(freightDeliveredAt);
  const end = deliveredAt ? DateTime.fromISO(deliveredAt) : undefined;

  return (
    <Age start={start} end={end} serviceLevelTarget={serviceLevelTarget} />
  );
}
